// Defines the choices for the Yes/No questions.
export const YES_NO_CHOICES = [
  { value: true, name: "Yes" },
  { value: false, name: "No" },
];

// Defines the 15 questions for the Geriatric Depression Scale.
export const GDS_QUESTIONS = [
  {
    name: "satisfied_with_life",
    label: "Are you basically satisfied with your life?",
  },
  {
    name: "dropped_activities",
    label: "Have you dropped many of your activities or interests?",
  },
  { name: "life_is_empty", label: "Do you feel that your life is empty?" },
  { name: "often_bored", label: "Do you often feel bored?" },
  {
    name: "in_good_spirits",
    label: "Are you in good spirits most of the time?",
  },
  {
    name: "afraid_something_bad",
    label: "Are you afraid that something bad is going to happen to you?",
  },
  { name: "happy_most_of_time", label: "Do you feel happy most of the time?" },
  { name: "often_feel_helpless", label: "Do you often feel helpless?" },
  {
    name: "prefer_to_stay_at_home",
    label:
      "Do you prefer to stay at home, rather than going and doing new things?",
  },
  {
    name: "problems_with_memory",
    label: "Do you feel you have more problems with your memory than most?",
  },
  {
    name: "wonderful_to_be_alive",
    label: "Do you think it is wonderful to be alive?",
  },
  {
    name: "feel_worthless",
    label: "Do you feel pretty worthless the way you are now?",
  },
  { name: "full_of_energy", label: "Do you feel full of energy?" },
  {
    name: "situation_is_hopeless",
    label: "Do you feel that your situation is hopeless?",
  },
  {
    name: "people_better_off",
    label: "Do you think that most people are better off than you are?",
  },
];

export const initialFormData = {
  care_plan: "",
  satisfied_with_life: null,
  dropped_activities: null,
  life_is_empty: null,
  often_bored: null,
  in_good_spirits: null,
  afraid_something_bad: null,
  happy_most_of_time: null,
  often_feel_helpless: null,
  prefer_to_stay_at_home: null,
  problems_with_memory: null,
  wonderful_to_be_alive: null,
  feel_worthless: null,
  full_of_energy: null,
  situation_is_hopeless: null,
  people_better_off: null,
  comments: "",
};

// Defines the risk levels based on the GDS score.
export const gdsRiskLevels = [
  {
    label: "Not Depressed",
    scoreRange: "0-4",
    description: "Symptoms of depression are considered unlikely.",
    color: "success",
  },
  {
    label: "Mildly Depressed",
    scoreRange: "5-8",
    description: "Suggests mild depression. Further monitoring is recommended.",
    color: "warning",
  },
  {
    label: "Severely Depressed",
    scoreRange: "9-15",
    description:
      "Highly indicative of severe depression. Requires clinical assessment and intervention.",
    color: "error",
  },
];
